import React from "react";
import { useNavigate } from "react-router-dom";
import MediaComponent from "./MediaComponent";
import "./SlideCard.css";

const SlideCard = ({ deck }) => {
  const navigate = useNavigate();
  const { client_name, client_brief, client_slides, _id: id } = deck;

  const handleCardClick = () => {
    // Default navigation to slide viewer
    navigate(`/slide-viewer/${id}`);
  };

  // Safety check for empty slides
  if (!client_slides || client_slides.length === 0) {
    return (
      <div className="slide-card">
        <div className="slide-card-image">
          <div className="no-slides-placeholder">
            <p>No slides available</p>
          </div>
        </div>
        <div className="slide-card-content">
          <h4 className="slide-card-title">{client_name}</h4>
          <p className="slide-card-description">{client_brief}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="slide-card"
      onClick={handleCardClick}>
      <div className="slide-card-image">
        <MediaComponent
          src={client_slides[0].location}
          alt={client_name}
          className="slide-card-preview"
          isPreview={true}
        />
        <div className="slide-count-badge">{client_slides.length} </div>
      </div>

      <div className="slide-card-content">
        <h4 className="slide-card-title">{client_name}</h4>
        <p className="slide-card-description">{client_brief}</p>

        <div className="slide-card-footer">
          <span className="view-slides-text">Click to view slides →</span>
        </div>
      </div>
    </div>
  );
};

export default SlideCard;
